export async function getLoginCaptchaPolicy(): Promise<{
  captchaRequired: boolean;
}> {
  const backendUrl = process.env.REACT_APP_BACKEND_WS;
  if (!backendUrl)
    throw new Error("No se pudo consultar la política de seguridad");
  const url = new URL("/login/captcha-policy", backendUrl);
  const response = await fetch(url.toString(), { cache: "no-store" });
  if (!response.ok)
    throw new Error("No se pudo consultar la política de seguridad");
  const policy = await response.json();
  if (!policy || typeof policy.captchaRequired !== "boolean") {
    throw new Error("No se pudo consultar la política de seguridad");
  }
  return { captchaRequired: policy.captchaRequired };
}
